<!--Loading display-->
<div class="col-12 text-center" *ngIf="busy">
    <div class="spinner-grow dooya-green-text" role="status">
        <span class="sr-only">Loading...</span>
    </div>
</div>
